import { ContentSubmissionScreen_ContentSubmissionFragment$key } from "@generated/ContentSubmissionScreen_ContentSubmissionFragment.graphql";
import { ContentSubmissionScreen_Query } from "@generated/ContentSubmissionScreen_Query.graphql";
import { graphql } from "babel-plugin-relay/macro";
import React from "react";
import { useFragment, useLazyLoadQuery } from "react-relay";
import { Navigate, useMatch } from "react-router-dom";
import { NodeContainer } from "../../infecto-lms-webapp-impl/containers/Node.container";
import {
	CONTENT_SUBMISSION_ID_URL_PARAM,
	getContentSubmissionPath,
} from "../../infecto-lms-webapp-impl/router/routes/auth/learn.routes";
import { PaediaContentElement } from "../components/content-element/PaediaContentElement.component";
import { ContentSubmissionEnd } from "../components/content-submission-end";

const QUERY = graphql`
	query ContentSubmissionScreen_Query($submissionId: ID!) {
		Viewer {
			Auth {
				currentUser {
					user {
						id
						...contentSubmissionEnd_UserFragment
					}
				}
			}
		}
		node(id: $submissionId) {
			... on ContentSubmission {
				id
				...ContentSubmissionScreen_ContentSubmissionFragment
			}
		}
	}
`;

const CONTENT_SUBMISSION_FRAGMENT = graphql`
	fragment ContentSubmissionScreen_ContentSubmissionFragment on ContentSubmission {
		id
		learnOpportunity {
			...NodeContainer_LearnOpportunityV2Fragment
		}
		definition {
			status
		}
		...contentSubmissionEnd_ContentSubmissionFragment
		...PaediaContentElement_ContentSubmissionFragment
	}
`;

export function ContentSubmissionScreen() {
	const {
		params: { contentSubmissionId },
	} = useMatch(getContentSubmissionPath(CONTENT_SUBMISSION_ID_URL_PARAM))!;

	const data = useLazyLoadQuery<ContentSubmissionScreen_Query>(QUERY, {
		submissionId: contentSubmissionId!,
	});

	const contentSubmission = useFragment<ContentSubmissionScreen_ContentSubmissionFragment$key>(
		CONTENT_SUBMISSION_FRAGMENT,
		data.node,
	);

	return contentSubmission && contentSubmission.learnOpportunity ? (
		<NodeContainer learnOpportunityFragmentRef={contentSubmission.learnOpportunity}>
			<>
				{contentSubmission.definition.status !== "active" && (
					<ContentSubmissionEnd
						contentSubmissionFragmentRef={contentSubmission}
						userFragmentRef={data.Viewer.Auth.currentUser?.user!}
					/>
				)}
				{contentSubmission.definition.status === "active" && (
					<PaediaContentElement contentSubmissionFragmentRef={contentSubmission} />
				)}
			</>
		</NodeContainer>
	) : (
		<Navigate to={"/"} />
	);
}
